import React from "react";
import PropTypes from "prop-types";
import { defaultTemplate } from "core/hoc";
import {
    BaasicFieldDropdown,
	NumericInputField,
	EditFormContent,
	BaasicButton
} from "core/components";

const FacilityInventoryCountDetailEditTemplate = function({ facilityInventoryCountDetailEditViewStore }) {
    
    const { 
		form ,
		productStore,
		duplicateItems,
        // productRef,
        // quantityRef,
        updateQuantity,
        eachProduct
    } = facilityInventoryCountDetailEditViewStore;

    // if(quantityRef.current !== null)
    // {
    //     quantityRef.current.element.current.onkeydown = (e) => {
    //         if(e.keyCode === 13)
    //         {
    //             form.onSubmit(e);
    //         }
    //     };
    // }
	return (
            <div className="row">
                <div className="col col-sml-10 col-lrg-10"> 
                    <div className="card card--form card--primary card--med">     
                        <EditFormContent form={form}>				
                            <div className="row row--form">
                                <div className="form__group col col-lrg-5 u-mar--bottom--sml">
                                    <BaasicFieldDropdown 
                                        // customRef={productRef} 
                                        focused={true} 
                                        field={form.$('productId')} 
                                        store={productStore} 
                                        disabled={false}
                                    />
                                </div>
                                <div className="form__group col col-lrg-3 u-mar--bottom--sml">
                                    <NumericInputField 
                                        // customRef={quantityRef} 
                                        field={form.$('caseQty')} 
                                        disabled={false}
                                        onBlur={(e) => {
                                            updateQuantity(e.target.value, 'caseQty');
                                        }}
                                        max={"999.99"}
                                        min={"0"}
                                    />
                                </div>	
                                <div className="form__group col col-lrg-3 u-mar--bottom--sml">
                                    <NumericInputField 
                                        // customRef={quantityRef} 
                                        field={form.$('eachQty')} 
                                        disabled={false}
                                        onBlur={(e) => {
                                            updateQuantity(e.target.value, 'eachQty');
                                        }}
                                        max={"999.99"}
                                        min={"0"}
                                    />
                                </div>	
                                <div className="form__group col col-lrg-1 u-mar--bottom--sml">
                                    <BaasicButton
                                        type='submit'
                                        className='btn btn--base btn--primary'
                                        label="Add"
                                        rotate
                                        icon={
                                            form.submitting || form.validating
                                                ? "u-icon u-icon--xmed u-icon--sync u-rotate--login"
                                                : 'u-display--none'
                                        }
                                        disabled={form.submitting || form.validating}
                                        onClick={form.onSubmit}
                                    />	
                                    
                                </div>	
                            </div>
                            <div className="row">
                                {duplicateItems != null && duplicateItems > 0 &&
                                    <div className="validation__message u-mar--bottom-tny u-mar--right-tny"> 
                                        <i className="u-icon u-icon--xsml u-icon--warning u-mar--right--tny"></i>
                                        There is already this product in this facility inventory count.
                                    </div>
                                }
                                {eachProduct == null &&
                                    <div className="validation__message u-mar--bottom-tny u-mar--right-tny"> 
                                        <i className="u-icon u-icon--xsml u-icon--warning u-mar--right--tny"></i>
                                        Item doesn't exist.
                                    </div>
                                } 
                            </div>
                        </EditFormContent>
                    </div>
                </div>
            </div>
    )
};

FacilityInventoryCountDetailEditTemplate.propTypes = {
	facilityInventoryCountDetailEditViewStore: PropTypes.object.isRequired,
	t: PropTypes.func,
};

export default defaultTemplate(FacilityInventoryCountDetailEditTemplate);